import React from 'react';
import { StyledH1 } from 'pages/Race/Race/Race.styled';
import { Button, Flex, Input, P } from 'ui';
import { StyledSelect } from 'pages/Race/SendAffiliateRequest/SendAffiliateRequest.styled';
import { FormState, UseFormRegister, UseFormSetValue } from 'react-hook-form/dist/types/form';
import { IFormData } from 'pages/Race/SendLeaderRequest';

type MessengerType = 'TG' | 'WA';

interface StepOneProps {
  register: UseFormRegister<IFormData>;
  formState: FormState<IFormData>;
  type: MessengerType;
  setValue: UseFormSetValue<IFormData>;
}

const OptionsSelect: { id: MessengerType; name: string }[] = [
  { id: 'TG', name: 'Telegram' },
  { id: 'WA', name: "What's App" },
];

export const StepOne: React.FC<StepOneProps> = ({ register, formState, type, setValue }) => {
  const onChoose = (value: 'TG' | 'WA') => {
    setValue('type', value);
  };

  return (
    <>
      <StyledH1 $isLeader>Participation application</StyledH1>
      <P size="md" align="left">
        Please fill in all fields of the form using only reliable and up-to-date information. This will help us in the
        selection of candidates
      </P>
      <Flex $direction="column" $align="flex-start" $justify="flex-start" $gap="form">
        <Input
          {...register('username', { required: true })}
          error={formState.errors.username?.message}
          disabled
          placeholder="Username"
        />
        <StyledSelect<MessengerType> chosen={type} options={OptionsSelect} onChoose={onChoose} placeholder="" />
        <Input
          {...register('contact')}
          error={formState.errors.contact?.message}
          placeholder="Telegram or What's App"
        />
        <Input
          {...register('audience')}
          error={formState.errors.audience?.message}
          placeholder="How big is your audience?"
          type="number"
        />
        <Input
          {...register('usdt')}
          error={formState.errors.usdt?.message}
          placeholder="Forecast for funds in USDT"
          type="number"
        />
        <Input {...register('additional')} placeholder="Additional questions" />
      </Flex>
      <Button type="submit">Continue</Button>
    </>
  );
};
